import styled from 'styled-components'
import { Link } from 'react-router-dom'
import EditIcon from '@material-ui/icons/Edit';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import ArrowDownwardIcon from '@material-ui/icons/ArrowUpward';

export const TableWrap = styled.div``

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;

`

export const THead = styled.thead``

export const TBody = styled.tbody``

export const Tr = styled.tr``

export const Th = styled.th`
    border: 1px solid #ccc;
    padding: 8px;
    text-align: left;
    color: #333;
    cursor: pointer;
`

export const Td = styled.td`
    border: 1px solid #ccc;
    padding: 8px;
    color: #333;
    word-break: break-all;
    line-height: 1.6;

    &:nth-child(1) {
        width: 20%;
    }

    &:nth-child(2) {
        width: 20%;
    }

    &:nth-child(3) {
        width: 15%;
    }

    &:nth-child(4) {
        width: 15%;
    }

    &:nth-child(5) {
        width: 15%;
    }
`

export const ActionWrap = styled.div`
    display: flex;
    justify-content: center;
`

export const EditButton = styled(Link)`
    text-decoration: none;
    margin-right: 15px;
    &:hover {
        opacity: 0.7;
    }
`

export const EditIconStyled = styled(EditIcon)`
    color: #5CB660;
    font-size: 30px;
`

export const DeleteButton = styled.div`
    cursor: pointer;
    &:hover {
        opacity: 0.7;
    }
`

export const DeleteIconStyled = styled(DeleteForeverIcon)`
    color: #F44336;
    font-size: 30px;
`

export const PaginationWrap = styled.div`
    margin: 30px 0;
    display: flex;
    justify-content: center;
`

export const TableHeader = styled.div`
    display: flex;
    margin: 0 0 20px; 
`

export const SortIcon = styled(ArrowDownwardIcon)`
    cursor: default;
    pointer-events: none;
    font-size: 24px;
    color: #666;
    margin-left: 6px;
    position: relative;
    bottom: 2px;
    transition: all .3s ease;
    transform: ${({type})=> type === 'desc' ? 'rotate(0)':'rotate(180deg)'};
`

export const Flexc = styled.div`
    display: flex;
    align-items: center;
    pointer-events: none;
`